import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.5 9c2.379-1.008 4.103-3 .5-5.43-2.097-1.008-4.194-.553-5.978.39-3.631 1.885-5.113 5.687-5.019 9.913.207 7.36 10.367 10.248 15.932 5.627s0-11.738 0-11.738"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m12.797 11.285 2.752 1.15c.45.204.558.751.18 1.067l-4.18 3.608c-.41.353-1.07.144-1.14-.376l-.763-5.652c-.07-.52.476-.892.96-.692"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const PlayVideoIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
